








































































































import { Prop, Component, Watch, Vue } from 'vue-property-decorator'
import { State, namespace } from 'vuex-class'
import moment from 'moment'
import HashTip from '@/components/HashTip.vue'

@Component({
  components: {
    HashTip,
  },
})
export default class Transaction extends Vue {
  @State('bp') bpState

  @Prop(String) hash!: string

  transaction = { tx: {} }
  loading = false

  // lifecycle hook
  mounted() {
    this.$store.dispatch('bp/connectBP').then(this.fetchData)
  }

  // watch
  @Watch('hash')
  onRouteHashChanged() {
    this.fetchData()
  }

  // async
  async fetchData() {
    this.loading = true
    try {
      let result = await this.$store.dispatch(
        'bp/getTransactionByHash',
        this.hash
      )

      this.transaction = result
      this.loading = false
    } catch (error) {
      console.error(error)
    }
  }

  // private methods
  private formatDate(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }
}
